<div #top></div>

<div class="grid-x grid-margin-x headline-wrapper">
  <div class="cell small-12 large-offset-1 large-10"><hr></div>
  <div class="cell small-12 large-offset-1 large-10 text-center">
    <h1 [innerHTML]="'heizcheck.' + mode + '.headline' | translate"></h1>
  </div>
  <div class="cell small-12 large-offset-1 large-10"><hr></div>
</div>

@if (mode === 'foto') {
  <div class="upload-wrapper show-for-medium">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 large-offset-1 large-10">
        <div class="grid-x grid-margin-x">
          <div class="cell small-4">
            <div class="image-wrapper step1">
              <img src="assets/img/smarthec-foto-1.png" alt="Browser auf einem Smartphone mit foto.co2online.de in der Adressleiste">
              <i class="icon-touch-finger"></i>
            </div>
            <div class="blue-box" [innerHTML]="'heizcheck.foto.step1' | translate: {url: redirectUrl}"></div>
          </div>
          <div class="cell small-4">
            <div class="image-wrapper step2">
              <img src="assets/img/smarthec-foto-1.png" alt="Browser auf einem Smartphone mit foto.co2online.de in der Adressleiste">
              <span class="label-dummy" [innerHTML]="'heizcheck.redirect.tan' | translate"></span>
              <span class="input-dummy">{{ fotoNumber }}</span>
              <i class="icon-touch-finger"></i>
            </div>
            <div class="blue-box" [innerHTML]="'heizcheck.foto.step2' | translate: {number: fotoNumber }"></div>
          </div>
          <div class="cell small-4">
            <div class="image-wrapper step3">
              <img src="assets/img/smarthec-foto-3.png" alt="Browser auf einem Smartphone mit Vorschau der Fotofunktion">
            </div>
            <div class="blue-box" [innerHTML]="'heizcheck.foto.step3' | translate"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 large-offset-1 large-10">
        <app-step-buttons previousLink="../../start" leftAlignSize="small" previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
      </div>
    </div>
  </div>
}

@if (mode === 'upload') {
  <div class="upload-wrapper">
    <div class="grid-x grid-margin-x step-form">
      <div class="cell small-12 medium-5 large-4 medium-order-2 help-wrapper">
        <button class="help-toggle hide-for-medium" [attr.aria-expanded]="showPageHelp" aria-controls="page-help" (click)="showPageHelp = !showPageHelp">{{(showPageHelp? 'step.help.toggle.close' : 'step.help.toggle.show') | translate}} <i [class]="showPageHelp? 'icon-x-circle' : 'icon-info'"></i></button>
        <div id="page-help" class="callout lighter-gray step-help" [class.show]="showPageHelp">
          <div [innerHTML]="'heizcheck.upload.description' | translate"></div>
        </div>
      </div>
      <div class="cell small-12 medium-7 large-offset-2 large-5 medium-order-1">
        <app-msp [(model)]="this.anfrage.heizkostenanalyseInput['messdienstleister']" (modelChange)="updateMsp($event)"></app-msp>
        <div class="formfield">
          <fieldset>
            <legend class="input-group-headline">Dateien auswählen</legend>
            @for (file of files; track file; let i = $index) {
              <div class="file-wrapper">
                <app-file-upload [id]="file.id" [label]="'heizcheck.upload.file.select'" [disabled]="isFileDisabled(file.id) === true && !file.file && i != 0" (fileChange)="onFileSelected($event)"></app-file-upload>
              </div>
            }
          </fieldset>
        </div>
        <app-terms [textPrefix]="'heizcheck.'" (onUpdate)="terms = $event"></app-terms>
      </div>
    </div>
    @if (error) {
      <div class="grid-x grid-margin-x no-print">
        <div class="cell medium-7 large-5 large-offset-2">
          <div role="alert" class="form-errors" [innerHTML]="('heizcheck.upload.error' + error) | translate"></div>
        </div>
      </div>
    }
    <div class="grid-x grid-margin-x button-wrapper no-print">
      <div class="cell large-2 medium-0 shrink small-text-right">
        <a class="button darker-gray hollow inline-arrow-left" routerLink="../../start"><i class="icon-arrow-left"></i><span [innerHTML]="'step.button.previous' | translate"></span></a>
      </div>
      <div class="auto cell large-5 medium-5">
        <app-upload-button [label]="getButtonText()" [uploadPercentage]="uploadPercentage" [class]="'button primary'" [disabled]="fileUploadPossible() !== 0" (click)="uploadData()"></app-upload-button>
        <p class="data-protection" [innerHTML]="'heizcheck.upload.submit.dataprotection' | translate"></p>
      </div>
    </div>
  </div>
}

@if (mode === 'result') {
  <div class="result-wrapper">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-3">
        <img [src]="detectedValueCount >= minDetectedValueCount? '/gfx/hec/ki-erfolg.svg' : '/gfx/hec/ki-error.svg'">
      </div>
      <div class="cell small-12 medium-6">
        <p [innerHTML]="(detectedValueCount >= minDetectedValueCount? 'heizcheck.result.ok' :'heizcheck.result.notok') | translate: {count: detectedValueCount}"></p>
      </div>
    </div>
    <app-step-buttons mediumOffset="3" largeOffset="3" previousLink="../../start" (onPreviousClick)="backFromtResult()" nextLink="../../../heizkostenabrechnung/basisdaten/1" [nextSubmit]="false"></app-step-buttons>
  </div>
}
